exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-toggle[data-v-57c3e676]::after {\n  display: none;\n}", ""]);

// exports
